import ApiServiceAxios from '../service/ApiServiceAxios';

let moduleApi = {};
let moduleName = "dot_khams";
let UrlApi = window.MyConfig.hostApi;
let UrlApiPacs = window.MyConfig.UrlApiPacs;
let applicationCode831 = window.MyConfig.applicationCode831;
let UrlApiEhr = window.MyConfig.hostApi831;

moduleApi.loginBSBiin = () => {
  let api = {
    method: "POST",
    url: UrlApi + "auth/login",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({
      account: "bs_biin",
      password: "bs_biin"
    }),
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
}

moduleApi.listDotKham = (cardCode, token) => {
  let api = {
    method: "GET",
    url: UrlApi + moduleName + "?maDangKy=" + cardCode,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      token: token,
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.chiTietLanKham = (idDotKhamChuaBenh, cardCode, hiddenMessage, token) => {
  let api = {
    method: "POST",
    url: UrlApi + moduleName + "/get_chi_phi_by_id_dot_kham_chua_benh?idDotKhamChuaBenh=" + idDotKhamChuaBenh + "&cardCode=" + (cardCode ? cardCode : ''),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-HTTP-Method-Override': "get_chi_phi_by_id_dot_kham_chua_benh",
      token: token,
    },
    message: {
      success: "hidden",
      error: (hiddenMessage ? "hidden" : ''),
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.requestOtp = (cardCode, phoneNumber, token) => {
  let api = {
    method: "POST",
    url: UrlApi + moduleName + "/requestOtp",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-HTTP-Method-Override': "requestOtp",
      token: token,
    },
    data: JSON.stringify({
      "cardCode": cardCode ,
      "phoneNumber": phoneNumber
    }),
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};


moduleApi.validateOtp = (cardCode, phoneNumber, otp, token) => {
  let api = {
    method: "POST",
    url: UrlApi + moduleName + "/validateOtp",
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-HTTP-Method-Override': "validateOtp",
      token: token,
    },
    data: JSON.stringify({
      "cardCode": cardCode,
      "phoneNumber": phoneNumber,
      "otp": otp
    }),
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.getPacs = (cardCode, token) => {
  let api = {
    method: "GET",
    url: UrlApiPacs + "GetDSCacLanChup",
    params: {
      token: token,
      ApplicationCode: applicationCode831,
      MasterPatientID: cardCode
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công"
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.listDotKhamByTTHC = (data, token) => {
  let api = {
    method: "POST",
    url: `${UrlApiEhr}GetDotVaoVienByBoHanhChanh?token=${token}&ApplicationCode=${applicationCode831}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: data,
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
}

moduleApi.getPacsByTTHC = (data, token) => {
  let api = {
    method: "POST",
    url: `${UrlApiPacs}GetDSCacLanChup?token=${token}&ApplicationCode=${applicationCode831}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    data: data,
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
}

export default moduleApi;
